import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useObservable } from '../../../../hooks/rxjs';
import { useRoomSession } from '../../../../context/room_session';
import { ToolbarButton } from './toolbar_button';
import { TooltipMessage } from './toolbar_tooltip_message';
import { normalizeAudioLevel } from '../../../../util/normalize_audio_level';
import { Theme } from '@streem/ui-react';
export const LocalAudioMuteButton = props => {
    const roomSession = useRoomSession();
    const [localAudioEnabled] = useObservable(roomSession.media.localAudio.enabled);
    const [localAudioStarted] = useObservable(roomSession.media.localAudio.started);
    const [localAudioLevel] = useObservable(roomSession.media.localAudio.audioLevel);
    const tooltipMessage = useMemo(() => {
        if (!localAudioStarted) {
            return 'No Microphone Found';
        }
        else if (localAudioStarted && localAudioEnabled) {
            return 'Mute';
        }
        else if (localAudioStarted && !localAudioEnabled) {
            return 'Unmute';
        }
        return '';
    }, [localAudioEnabled, localAudioStarted]);
    return (_jsx(ToolbarButton, { "data-testid": tooltipMessage, tooltipMessage: _jsx(TooltipMessage, { text: tooltipMessage }), fillLevel: localAudioEnabled ? normalizeAudioLevel(localAudioLevel) : undefined, disableButton: !localAudioStarted, label: "Audio", iconName: localAudioEnabled ? 'MuteIcon' : 'MutedIcon', onClick: () => roomSession.media.localAudio.setEnabled(!localAudioEnabled), buttonStyles: {
            paddingRight: '.5rem',
            minWidth: '4.0rem',
        }, slashcolor: Theme.colors.red50, ...props }));
};
//# sourceMappingURL=local_audio_mute_button.js.map